(function () {
  function wrapOnce(proto) {
    if (!proto || typeof proto.updateProductStickyInfo !== "function") return false;
    if (proto.updateProductStickyInfo.__hotfixed) return true;

    const original = proto.updateProductStickyInfo;

    function safeUpdateProductStickyInfo(t) {
      // Hard guard: do not allow sticky component errors to break product page JS
      if (!this || !this.elms || !this.elms.product_sticky_info) return;

      try {
        return original.call(this, t);
      } catch (err) {
        // Fail soft: log a warning, but do not throw
        console.warn("[hotfix] updateProductStickyInfo prevented crash", err);
        return;
      }
    }

    safeUpdateProductStickyInfo.__hotfixed = true;
    proto.updateProductStickyInfo = safeUpdateProductStickyInfo;
    return true;
  }

  function patch() {
    // Attempt to find the class behind the custom element.
    // We cannot assume the tag name, so we scan defined custom elements if possible.
    // Many themes define a single product component element; we patch whichever has the method.

    // If your theme uses a known tag name, you can hardcode it here for speed:
    // const Ctor = customElements.get('sht-product') || customElements.get('product-form') || null;

    let patched = false;

    // Best-effort: check a shortlist of common element names
    const candidates = [
      "sht-product",
      "sht-product-info",
      "sht-product-form",
      "product-form",
      "product-info",
      "sticky-add-to-cart"
    ];

    for (const name of candidates) {
      const Ctor = customElements.get(name);
      if (Ctor && wrapOnce(Ctor.prototype)) patched = true;
    }

    // If none of the known names worked, patch instances on the page (fallback).
    if (!patched) {
      const nodes = document.querySelectorAll("*");
      for (const node of nodes) {
        const proto = Object.getPrototypeOf(node);
        if (proto && wrapOnce(proto)) {
          patched = true;
        }
      }
    }

    if (!patched) {
      // Not fatal; just means we didn't find the component
      console.warn("[hotfix] No component found to patch updateProductStickyInfo");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", patch, { once: true });
  } else {
    patch();
  }
})();